<div class="preloader" *ngIf="loading">
  <div class="spinner">
    <div class="double-bounce1"></div>
    <div class="double-bounce2"></div>
  </div>
</div>
<router-outlet>
</router-outlet>
